import { create } from 'zustand';

type AppState = {
  activeSlideIndex: number;
  aiDirectorOpen: boolean;
  speakerNotesOpen: boolean;
  unsavedSlideIds: string[];
  setActiveSlideIndex: (index: number) => void;
  setAiDirectorOpen: (open: boolean) => void;
  toggleAiDirector: () => void;
  setSpeakerNotesOpen: (open: boolean) => void;
  markSlideUnsaved: (slideId: string) => void;
  markSlideSaved: (slideId: string) => void;
};

export const useAppStore = create<AppState>((set) => ({
  activeSlideIndex: 0,
  aiDirectorOpen: false,
  speakerNotesOpen: false,
  unsavedSlideIds: [],
  setActiveSlideIndex: (index) => set({ activeSlideIndex: index }),
  setAiDirectorOpen: (open) => set({ aiDirectorOpen: open }),
  toggleAiDirector: () => set((state) => ({ aiDirectorOpen: !state.aiDirectorOpen })),
  setSpeakerNotesOpen: (open) => set({ speakerNotesOpen: open }),
  markSlideUnsaved: (slideId) =>
    set((state) => ({
      unsavedSlideIds: state.unsavedSlideIds.includes(slideId)
        ? state.unsavedSlideIds
        : [...state.unsavedSlideIds, slideId],
    })),
  markSlideSaved: (slideId) =>
    set((state) => ({
      unsavedSlideIds: state.unsavedSlideIds.filter((id) => id !== slideId),
    })),
}));
